import { useCallback } from 'react';
import type React from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useTemplatePageData } from '#src/app/pages/landing/template/pageContext';

import { trackLandingPageCtaClick } from './api/track';
import { Body } from './components/Body';
import { Footer } from './components/Footer';
import { FooterCta } from './components/FooterCta';
import { Header } from './components/Header';
import { useTrackView } from './hooks/useTrackView';

export const RenderTemplate: React.FC = () => {
	const {
		data: { slug },
	} = useTemplatePageData();
	const track = useTracking();
	useTrackView(slug);

	const onCtaClick = useCallback(async () => trackLandingPageCtaClick(slug, track), [slug, track]);

	return (
		<>
			<Header slug={slug} onCtaClick={onCtaClick} />
			<Body slug={slug} onCtaClick={onCtaClick} />
			<Footer slug={slug} />
			<FooterCta slug={slug} onCtaClick={onCtaClick} />
		</>
	);
};
